(function ($) {
    $(document).ready(function () {
        galleryCarousel();
    });

    function fixFancyboxSlick(innerElem) {
        return;
        // Fix for mini gallery fancy box
        var selector = '.slick-slide:not(.slick-cloned)';
        if (innerElem) {
            selector = selector + ' ' + innerElem;
        }
        // Skip cloned elements
        $().fancybox({
            selector: selector,
            backFocus: false,
            loop: true

        });
        // Remove fancybox cloned elements
        if (innerElem) {
            $('.slick-cloned ' + innerElem).each(function () {
                $(this).removeAttr('data-fancybox');
            });

        } else {
            $('.slick-cloned .thumb').removeAttr('data-fancybox');
        }


        // Attach custom click event on cloned elements,
        // trigger click event on corresponding link
        var clonedElement = '.slick-cloned';
        if (innerElem) {
            clonedElement = '.slick-cloned ' + innerElem;
        }
        $(document).on('click', clonedElement, function (e) {
            $(selector)
                .eq(($(e.currentTarget).attr("data-slick-index") || 0) % $(selector).length)
                .trigger("click.fb-start", {
                    $trigger: $(this)
                });

            return false;
        });
    }

    function galleryCarousel() {
        function setBoundries(slick, state) {
            if (state === 'default') {
                slick.find('ul.slick-dots li').eq(3).addClass('n-small-1');
            }
        }

        // Slick Selector.
        var maxDots = 3;
        var transformXIntervalNext = -30;
        var transformXIntervalPrev = 30;
        var wrapper = $('.gallery_section.carousel');
        wrapper.each(function () {
            var current = $(this);
            var wrap = current.find('.slider_inner_wrap');
            var hasCarousel = false;
            var numberItems = wrap.children().length;
            if (is_phone && numberItems > 1) {
                hasCarousel = true;
            } else if (is_mobile && numberItems > 2) {
                hasCarousel = true;
            } else if (!is_phone && !is_desktop_large && numberItems > 3) {
                hasCarousel = true;
            } else {
                if (numberItems > 3) {
                    hasCarousel = true;
                }
            }


            if (wrap.length > 0) {
                wrap.on("init", function () {
                    lazyLoadInstance.update();

                    current.find('ul.slick-dots').wrap("<div class='slick-dots-container'></div>");
                    current.find('ul.slick-dots li').each(function (index) {
                        $(this).addClass('dot-index-' + index);
                    });
                    current.find('ul.slick-dots').css('transform', 'translateX(0)');
                    setBoundries(current, 'default');
                });

                var transformCount = 0;
                wrap.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    var totalCount = current.find('.slick-dots li').length;
                    if (totalCount > maxDots) {
                        if (nextSlide > currentSlide) {
                            if (current.find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-small-1')) {
                                if (!$(this).find('ul.slick-dots li:last-child').hasClass('n-small-1')) {
                                    transformCount = transformCount + transformXIntervalNext;
                                    current.find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-small-1');
                                    var nextSlidePlusOne = nextSlide + 1;
                                    current.find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small-1');
                                    current.find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                                    var pPointer = nextSlide - 2;
                                    var pPointerMinusOne = pPointer - 1;
                                    current.find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-small-1');
                                    current.find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
                                }
                            }
                        } else {
                            if (current.find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-small-1')) {
                                if (!$(this).find('ul.slick-dots li:first-child').hasClass('p-small-1')) {
                                    transformCount = transformCount + transformXIntervalPrev;
                                    current.find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-small-1');
                                    var nextSlidePlusOne = nextSlide - 1;
                                    current.find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small-1');
                                    current.find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                                    var nPointer = currentSlide + 2;
                                    var nPointerMinusOne = nPointer - 1;
                                    current.find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
                                    current.find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small-1');
                                }
                            }
                        }
                    }
                });

                if (hasCarousel) {
                    wrap.slick({
                        rows: 0,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        focusOnSelect: true,
                        swipeToSlide: false,
                        touchMove: false,
                        arrows: true,
                        dots: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        appendDots: current.find('.pager'),
                        centerMode: false,
                        variableWidth: false,
                        rtl: $('html').attr('dir') === 'rtl',
                        responsive: [
                            {
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            },
                        ]
                    });
                }

                fixFancyboxSlick('.thumb_content .description');
                wrap.trigger('builder_gallery_ready');

                var select = current.find('.filters_select select');
                var filters = {};

                select.change(function () {
                    var $this = $(this);
                    var group = $this.attr('data-filter-group');

                    $this.trigger('builder_gallery_select_click');

                    filters[group] = $this.find(':selected').attr('data-filter-value');
                    var isoFilters = [];
                    for (var prop in filters) {
                        isoFilters.push(filters[prop])
                    }
                    var selector = isoFilters.join(''),
                        newRel = selector.replace('.', '');
                    wrap.find('.thumb_wrap' + selector).find('.thumb').attr("data-fancybox", newRel + '_thumb');
                    wrap.slick('slickUnfilter');

                    if (selector !== '') {
                        wrap.slick('slickFilter', selector);
                    }
                    fixFancyboxSlick('.thumb_content .description');
                    return false;
                });
            }
        });
    }

}(jQuery));